import vSelect from 'vue-select';
import 'vue-loading-overlay/dist/vue-loading.css';

import TokenInvalidModal from "@c/TokenInvalidModal"
import SpeichernErfolgreichModal from "@c/SpeichernErfolgreichModal"
import UnexpectedErrorModal from "@c/UnexpectedErrorModal"
import ValidationFailureModal from "@c/ValidationFailureModal"

/**
 * Setup Global accessible Components for the Vue instance
 * @param {VueConstructor<Vue>} instance
 */
export function setupGlobalComponents (instance) {

  instance.component('v-select', vSelect);

  instance.component('token-invalid-modal', TokenInvalidModal);
  instance.component('speichern-erfolgreich-modal', SpeichernErfolgreichModal);
  instance.component('unexpected-error-modal', UnexpectedErrorModal);
  instance.component('validation-failure-modal', ValidationFailureModal);

}

